export default __webpack_public_path__ + "static/media/warm.80ae8102.jpg";